import { jsx as r } from "react/jsx-runtime";
import o from "./index.es5734.js";
const m = ({ children: t }) => /* @__PURE__ */ r("div", { className: o.wrapper, children: /* @__PURE__ */ r("div", { className: o.buttons, children: t }) });
export {
  m as FooterButtonGroup
};
//# sourceMappingURL=index.es5457.js.map
